import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PartialitiesArea } from "./Styles";

export default function Partialities({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Parcialidades"
            value={!value ? document.partialities.totalPartialities : value}
          />
        </div>
      ) : (
        <PartialitiesArea>
          <Informative
            readonly={true}
            label="Parcialidades"
            value={!value ? document.partialities.totalPartialities : value}
          />
        </PartialitiesArea>
      )}
    </>
  );
}
